import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { HostOptions } from '../../host/contracts';
import { RESOLVED_UI_LABELS } from '../config/constants.js';

const LocaleContext = createContext(RESOLVED_UI_LABELS);
export const LocaleProvider = ({ uiLabels, children }: Pick<HostOptions, 'uiLabels'> & { children?: ReactNode }) => {
  const value = useMemo(() => ({ ...RESOLVED_UI_LABELS, ...uiLabels }), [uiLabels]);
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
};
export const useLocale = () => useContext(LocaleContext);
